import { render, staticRenderFns } from "./BtnAction.vue?vue&type=template&id=9ede64ca"
import script from "./BtnAction.vue?vue&type=script&lang=js"
export * from "./BtnAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports